import { tryCurrentRuntime } from './currentRuntime';
import { identityOf } from './identity';

/**
 * The accounts on a log line, looked up when the line is written, for the runtime of the request
 * being rendered (server) or of the app (browser). No runtime to be found means no accounts on the
 * line, never somebody else's.
 */
export function enrichLogEvent(clone: Record<string, any>): void {
    const runtime = tryCurrentRuntime();
    const { mainAccount, activeAccount } = runtime ? identityOf(runtime.queryClient) : { mainAccount: null, activeAccount: null };
    if (mainAccount) {
        clone['MainAccount'] = mainAccount;
        clone['MainAccountId'] = mainAccount.accountId;
    }
    if (activeAccount) {
        clone['ActiveAccount'] = activeAccount;
        clone['ActiveAccountId'] = activeAccount.accountId;
    }
    clone['Uri'] = globalThis.window?.location?.href;
    // Source maps are stripped from the image, so an error is only traceable back to source via
    // the frontend-sourcemaps artifact of this exact build.
    clone['BuildId'] = import.meta.env.VITE_BUILD_ID;
}
